export const Device = {
    getDeviceId: async () => {
        let imei = undefined;
        try {
            imei = await Imei.get();
            if (imei !== undefined && imei !== null) {
                return imei;
            }
        }catch (e) {
            console.error(e);
            errorHandler.tomcatError(e,false,`Device Error`)
        }
        return null;
    },
}
